import PlatformsIcon from '@material-ui/icons/ImportantDevices';

import PlatformsList from './PlatformsList';
// import PlatformsEdit from './PlatformsEdit';

export default {
    list: PlatformsList,
    // edit:PlatformsEdit,
    icon: PlatformsIcon,
};
